import { render } from "./Twitter.vue?vue&type=template&id=470ce96a&scoped=true"
import script from "./Twitter.vue?vue&type=script&lang=js"
export * from "./Twitter.vue?vue&type=script&lang=js"

import "./Twitter.vue?vue&type=style&index=0&id=470ce96a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ce96a"]])

export default __exports__